import { Row, Col, Form } from "antd"
import { Input, Button, TextTag as Text, Logo } from "../../atoms"
import { withFormik } from "formik"
import React from "react"
import { connect } from "react-redux"
import logo from "../../assets/images/logo.svg"
import "./ForgotPassword.scss"
import {
  verifyPasswordReset,
  setPassword,
} from "../../redux/actionCreators/auth"
import { ConfirmForgotPasswordValidation } from "../../validationSchema/EmailSigninSignupValidation"
import {
  EMAIL_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
  PASSWORD_SET_SUCCESSFULLY,
  EXPIRED_LINK,
  LOGIN_LINK,
  PASSWORD_RESET_TITLE,
  RESET_PASSWORD_BUTTON,
  RESET_PASSWORD_FORM_LINK,
  CONFIRM_PASSWORD_PLACEHOLDER,
  PRODUCT_NAME,
} from "../../constants/messages"
import DjangoCSRFToken from "django-react-csrftoken"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import { getFormattedAPIEndPoint } from "../../utils/urlFormations"
import config from "../../config"
import _ from "../../utils/lodashUtils"
import { Link } from "react-router-dom"

const FormItem = Form.Item

/* After clicking on password reset link
1. Validate the link
2. Ask for password
3. validate and update password */
class S extends React.PureComponent {
  state = {
    email: "",
    error: false,
  }
  componentDidMount() {
    if (this.props.match.params.uuid !== "done") {
      this.props
        .verifyPasswordReset(
          this.props.match.params.uuid,
          this.props.match.params.token
        )
        .then(
          success => {
            //hide the email which is trying to change password
            let email = success.data.email.replace(
              /^(.{1})[^@]+/gim,
              "$1**********"
            )
            //https://stackoverflow.com/questions/56913030/i-need-regex-to-mask-email-address-in-javascript

            this.setState({ email: email })
          },
          error => {
            this.setState({ error: true })
          }
        )
    }
  }
  render() {
    const {
      values,
      handleSubmit,
      handleChange,
      handleBlur,
      touched,
      errors,
      isSubmitting,
      isValid,
      dirty,
      setFieldTouched,
    } = this.props

    values.email = _.get(this.state, "email", "")

    const URL = getFormattedAPIEndPoint(ENDPOINTS.PASSWORD_RESET_URL, {
      $uuid: this.props.match.params.uuid,
      $token: this.props.match.params.token,
    })

    return (
      <div id="ForgotPassword">
        <div className="outer-container">
          <div className="forgot-password">
            <div className="title-text">
              <Text textType="spaceName"> {PASSWORD_RESET_TITLE}</Text>{" "}
            </div>
            {this.state.error === false ? (
              this.props.match.params.uuid === "done" ? (
                <div className="title-text-info">
                  <div>
                    <Text textType="sectionTextPrimary">
                      {PASSWORD_SET_SUCCESSFULLY}
                    </Text>{" "}
                  </div>
                  <Button
                    btnType="primary"
                    btnSize="large"
                    className="login-form-button"
                  >
                    <Link to="/login-email">{LOGIN_LINK}</Link>
                  </Button>
                </div>
              ) : (
                <form action={config.baseUrl + URL} method="post">
                  <DjangoCSRFToken />
                  <FormItem
                    validateStatus={
                      touched.email && errors.email ? "error" : undefined
                    }
                  >
                    <Input
                      name="email"
                      placeholder={EMAIL_PLACEHOLDER}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      error={touched.email && errors.email ? errors.email : ""}
                      readOnly={true}
                    />
                  </FormItem>
                  <FormItem
                    validateStatus={
                      touched.password && errors.password ? "error" : undefined
                    }
                  >
                    <Input
                      name="password"
                      type="password"
                      placeholder={PASSWORD_PLACEHOLDER}
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onInput={() => setFieldTouched("password", true)}
                      error={
                        touched.password && errors.password
                          ? errors.password
                          : ""
                      }
                    />
                  </FormItem>
                  <FormItem
                    validateStatus={
                      touched.confirmPassword && errors.confirmPassword
                        ? "error"
                        : undefined
                    }
                  >
                    <Input
                      name="confirmPassword"
                      type="password"
                      placeholder={CONFIRM_PASSWORD_PLACEHOLDER}
                      value={values.confPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onInput={() => setFieldTouched("confirmPassword", true)}
                      error={
                        touched.confirmPassword && errors.confirmPassword
                          ? errors.confirmPassword
                          : ""
                      }
                    />
                  </FormItem>
                  <FormItem>
                    <Button
                      btnSize="large"
                      htmlType="submit"
                      className="login-form-button"
                      disabled={isSubmitting || !dirty || !isValid}
                    >
                      {RESET_PASSWORD_BUTTON}
                    </Button>
                  </FormItem>
                </form>
              )
            ) : (
              <div className="title-text-info error">
                {EXPIRED_LINK}
                <Button btnSize="large" btnType="primary">
                  <Link to="/verify-email/initial">
                    {RESET_PASSWORD_FORM_LINK}
                  </Link>
                </Button>
              </div>
            )}
          </div>
          <div></div>
        </div>
      </div>
    )
  }
}

export const ForgotPassword = withFormik({
  validationSchema: ConfirmForgotPasswordValidation,
  mapPropsToValues: props => ({
    email: "",
    password: "",
  }),
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    // const URL = getFormattedAPIEndPoint(ENDPOINTS.PASSWORD_RESET_URL, {
    //   $token: props.match.params.uuid,
    // })
  },
})(S)

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps, { verifyPasswordReset, setPassword })(
  ForgotPassword
)
